<div class="content-panel">

  <h2 translate>SCHEDULE_INTERVIEW.LOCATION.BANNER</h2>

  <!-- <div class="well appointment-summary" *ngIf="selectedLocation?.name.length > 0">
  <dl class="list-inline">
    <dt translate>SCHEDULE_INTERVIEW.LOCATION_LABEL</dt>
    <dd>{{selectedLocation.name}}</dd>
  </dl>
</div> -->

<location-filter (onFilter)="filterLocations($event)"></location-filter>

<div class="row">
  <div class="col-12">
    <a href="" data-bs-toggle="modal" data-bs-target="#helpModal" title="{{'SCHEDULE_INTERVIEW.LOCATION.MULTI_FAMILY' | translate}}" translate>SCHEDULE_INTERVIEW.LOCATION.MULTI_FAMILY</a>
  </div>
</div>

@if (_usLocations || _caLocations || _otherLocations || hasAccessCodeLocation) {
  <div class="row">
    <div class="col-12">
      <div class="panel-group accordion" id="accordion" role="tablist" aria-multiselectable="true">
        <!-- US locations panel -->
        @if (_usLocations && _usLocations.length > 0) {
          <div class="card">
            <div class="card-header" role="tab" id="headingTwo">
              <h4 class="panel-title">
                <span id="collapse-arrow" class="fa fa-chevron-down"></span>
                <a role="button" data-bs-toggle="collapse" href="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                  <span translate>SCHEDULE_INTERVIEW.LOCATION.ACCORDION.US</span>
                </a>
              </h4>
            </div>
            <div id="collapseTwo" class="show" role="tabpanel" aria-labelledby="headingTwo">
              <div class="card-body">
                <div class="btn-group" role="group">
                  <button type="button" class="btn btn-default" style="white-space: normal" [class.btn-selected]="view === 'alpha'" (click)="view = 'alpha'" translate>GENERAL_REUSABLE.BUTTON_LABEL.ALPHA_LOCATIONS</button>
                  <button type="button" class="btn btn-default" style="white-space: normal" [class.btn-selected]="view === 'region'" (click)="view = 'region'" translate>GENERAL_REUSABLE.BUTTON_LABEL.REGION_LOCATIONS</button>
                </div>
                @if (view === 'alpha') {
                  <location-list [locations]="_usLocations" [panelID]="'US'" [viewOnly]="false" (locationSelected)="onLocationSelected($event)"></location-list>
                }
                @if (view === 'region') {
                  <region-list [regions]="_regionalLocations" [viewOnly]="false" (locationSelected)="onLocationSelected($event)"></region-list>
                }
              </div>
            </div>
          </div>
        }
        <!-- Canada locations panel -->
        @if ((_caLocations && _caLocations.length > 0) || isCBSAEligible()) {
          <div class="card">
            <div class="card-header" role="tab" id="headingThree">
              <h4 class="panel-title">
                <span id="collapse-arrow" class="fa fa-chevron-right"></span>
                <a role="button" data-bs-toggle="collapse" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree" translate>
                  SCHEDULE_INTERVIEW.LOCATION.ACCORDION.CANADA
                </a>
              </h4>
            </div>
            <div id="collapseThree" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
              <div class="card-body">
                <div><h2>{{'SCHEDULE_INTERVIEW.LOCATION.LAND_ENROLLMENT_CENTRES' | translate | uppercase}}</h2></div>
                <location-list [locations]="_caLocations" [panelID]="'CA'" [viewOnly]="false" (locationSelected)="onLocationSelected($event)"></location-list>
                @if (isCBSAEligible()) {
                  <div style="margin-top: 15px;" class="row">
                    <div class="col-12"><h2>{{'SCHEDULE_INTERVIEW.LOCATION.AIRPORT_ENROLLMENT_CENTRES' | translate| uppercase}}</h2></div>
                    <div class="col-12 mb-3">
                      <a tabindex="0" class="cbsa-schedule-link" href="javascript:void(0)" title="{{'SCHEDULE_INTERVIEW.LOCATION.OTHER_LOCATIONS_CA' | translate}}" (click)="onOtherCALocationsSelected()" (key.enter)="onOtherCALocationsSelected()" translate>SCHEDULE_INTERVIEW.LOCATION.OTHER_LOCATIONS_CA</a>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
        <!-- Other Countries locations -->
        @if (_otherLocations && _otherLocations.length > 0) {
          <div class="card">
            <div class="card-header" role="tab" id="headingFour">
              <h4 class="panel-title">
                <span id="collapse-arrow" class="fa fa-chevron-right"></span>
                <a role="button" data-bs-toggle="collapse" href="#collapseFour" aria-expanded="false" aria-controls="collapseFour" translate>
                  SCHEDULE_INTERVIEW.LOCATION.ACCORDION.OTHER
                </a>
              </h4>
            </div>
            <div id="collapseFour" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFour">
              <div class="card-body">
                @for (country of _otherLocations; track country; let i = $index) {
                  <h2 class="text-capitalize">{{country[0][0].countryName}}</h2>
                  <location-list [locations]="country" [panelID]="'other'+i" [viewOnly]="false" (locationSelected)="onLocationSelected($event)"></location-list>
                }
              </div>
            </div>
          </div>
        }
        <!-- access code locations panel -->
        @if (hasAccessCodeLocation) {
          <div class="card">
            <div class="panel-heading" role="tab" id="headingOne">
              <h4 class="card-header">
                <span id="collapse-arrow" class="fa fa-chevron-down"></span>
                <a role="button" data-bs-toggle="collapse" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne" translate>
                  SCHEDULE_INTERVIEW.LOCATION.ACCORDION.ACCESS_CODE
                </a>
              </h4>
            </div>
            <div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <p [innerHTML]="'SCHEDULE_INTERVIEW.LOCATION.NOTE' | translate"></p>
                  </div>
                </div>
                <location-list [locations]="_accessCodeLocations" [panelID]="'code'" [viewOnly]="false" (locationSelected)="onLocationSelected($event)"></location-list>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  }<!-- end of accordion section -->

  @if (!_usLocations && !_caLocations && !_otherLocations && !hasAccessCodeLocation) {
    <div class="alert alert-danger">
      <p translate>SCHEDULE_INTERVIEW.LOCATION.NO_LOCATIONS_FOUND</p>
    </div>
  }

  <div class="row">
    <div class="col-xs-10 col-sm-4">
      <strong><a href="" data-bs-toggle="modal" data-bs-target="#accessCodeModal" title="{{'SCHEDULE_INTERVIEW.LOCATION.ACCESS_CODE_QUESTION' | translate}}?" translate>SCHEDULE_INTERVIEW.LOCATION.ACCESS_CODE_QUESTION</a></strong>
    </div>
    <div class="col-sm-1">
      <tooltip [tooltip-text]="'SCHEDULE_INTERVIEW.LOCATION.ACCESS_CODE_TOOLTIP'"></tooltip>
    </div>
  </div>

</div>

<!-- Access Code modal -->
<div id="accessCodeModal" class="modal fade" tabindex="-1" role="dialog" data-bs-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-center" translate>SCHEDULE_INTERVIEW.LOCATION.MODAL.TITLE</h4>
        <button type="button" class="ttp-btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="accessCode = ''"><span aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <div class="float-end">
              <span class="required">* <span translate>GENERAL_REUSABLE.REQUIRED_FIELD</span></span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <span translate>SCHEDULE_INTERVIEW.LOCATION.MODAL.ACCESS_CODE_QUESTION</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="txtAccessCode"><span class="required">*</span> <span translate>SCHEDULE_INTERVIEW.LOCATION.MODAL.ACCESS_CODE</span></label>
            <input id="txtAccessCode" [(ngModel)]="accessCode" class="form-control">
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <div class="col-12 col-lg-4 mb-3 align-self-start">
          <button id="cancelBtn" type="button" class="btn w-100 d-block btn-default" data-bs-dismiss="modal" (click)="accessCode = ''" translate>
            GENERAL_REUSABLE.BUTTON_LABEL.CANCEL
          </button>
        </div>
        <div class="col-12 col-lg-4 mb-3">
          <button id="submitCode" type="button" class="btn w-100 d-block btn-primary" (click)="submitAccessCode()" [disabled]="accessCode.length <= 0" translate>
            GENERAL_REUSABLE.BUTTON_LABEL.SUBMIT
          </button>
          <sub [innerHTML]="'SCHEDULE_INTERVIEW.LOCATION.MODAL.PROCEED' | translate"></sub>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Help Modal -->
<div id="helpModal" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-center" translate>MODAL.MULTI_FAMILY_TITLE</h4>
        <button type="button" class="ttp-btn-close" data-bs-dismiss="modal" aria-label="close"><span aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <div [innerHTML]="'MODAL.MULTI_FAMILY_BODY' | translate"></div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row justify-content-center w-100">
          <div class="col-lg-4 form-group">
            <button id="closeModal" type="button" class="btn w-100 btn-primary" data-bs-dismiss="modal" translate>
              MODAL.BUTTON_CLOSE
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

